// extracted by mini-css-extract-plugin
export default {"info":"mDyWtpgKkn","h-rule":"_2WCrEZOFVI","hRule":"_2WCrEZOFVI"};